import React from 'react';
import PropTypes from 'prop-types';

const CategoryLabel = ({ category, page }) => {
  const { title, color, iconUrl } = category;

  const styles = {
    color: `#${color}`,
  };

  return (
    <>
      {page === 'auctions' && (
        <div className="label-mobile">
          <div>
            <img
              className="carousel-icon mr-1"
              src={iconUrl}
              style={styles}
              alt={title} />
          </div>
          <div style={styles}>{title}</div>
        </div>
      )}

      {page === 'home' && (
        <div className="label">
          <div>
            <img
              className="carousel-icon mr-1"
              src={iconUrl}
              style={styles}
              alt={title} />
          </div>
          <div style={styles}>{title}</div>
        </div>
      )}
    </>
  );
};

CategoryLabel.propTypes = {
  page: PropTypes.string.isRequired,
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default CategoryLabel;
